export default __webpack_public_path__ + "static/media/Hard-Work-With-no-Fruits.de889fa2.webp";